import React from 'react';
import { useCommissionsList } from '../hooks/use-commissions-list.js';
import CommissionsPageView from './commissions-page-view.jsx';

function CommissionsPageContainer() {
  const state = useCommissionsList();
  return <CommissionsPageView {...state} />;
}

export default CommissionsPageContainer;
